export const getWebAgentVersion = (socket) => {
    return new Promise((resolve) => {
        if (!socket) {
            console.log('No socket available')
            resolve(null)
            return
        }

        if (!socket.connected) {
            console.log('Socket is not connected')
            resolve(null)
            return
        }

        // Try multiple possible event response names
        socket.emit('version', (response) => {
            console.log('version: is ', response)
            return resolve(response || null)
        })
    })
}

export const getAssetsVersion = async (socket, deviceFolder = 'zing') => {
    try {
        if (!socket) {
            console.log('No socket available for assets version')
            return null
        }

        // Get mount point
        const mountPoint = await new Promise((resolve, reject) => {
            socket.emit('list-mount', (response) => {
                if (response.success && response.output) {
                    resolve(response.output)
                } else {
                    reject(new Error('Failed to get mount point'))
                }
            })
        })
        if (!mountPoint) {
            console.log('No mount point found')
            return null
        }
        console.log('Mount point:', mountPoint)

        // Read meta.yaml file
        const devicePath = `${mountPoint}/${deviceFolder}`
        const metaYamlPath = `${devicePath}/meta.yaml`

        const fileResponse = await new Promise((resolve) => {
            socket.emit(
                'read-file',
                { file_path: metaYamlPath },
                (response) => {
                    resolve(response)
                }
            )
        })

        if (!fileResponse.success) {
            console.log('No meta.yaml found on device')
            return null
        }

        // Decode base64 and parse YAML
        const base64Data = fileResponse.output
        const yamlContent = atob(base64Data)

        // Simple YAML parser for version field
        const versionMatch = yamlContent.match(
            /version:\s*["']?([^"'\n]+)["']?/
        )

        if (versionMatch && versionMatch[1]) {
            const version = versionMatch[1].trim()
            console.log('Assets version from meta.yaml:', version)
            return version
        }

        return null
    } catch (error) {
        console.error('Error getting assets version:', error)
        return null
    }
}
